import { render, staticRenderFns } from "./AdminLogoutLog.vue?vue&type=template&id=5a1c2454"
import script from "./AdminLogoutLog.vue?vue&type=script&lang=js"
export * from "./AdminLogoutLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports